import React from "react";
import "./SupplyChain.scss";

import Image from "../../Assits/Supply-Chain-Management.jpg";
const SupplyChain = () => {
  return (
    <div className="SupplyChain">
      <h2>Supply Chain Division</h2>

      <img alt="Supply Chain" src={Image} />
      <p>
        Our Supply Chain Division has special expertise in Oil &amp; Gas and
        energy sector equipments and related services. With our long
        outstanding, proven &amp; trusted relationship with the world leading
        manufacturers and engineering companies, Petro-en Trading & Engineering
        supply chain division enjoys a unique position for sourcing and
        supplying required products and related services timely, efficiently and
        effectively meeting and exceeding our customers’ requirements. Further
        to this, we not only source and deliver the right product at the right
        time but do have a competitive advantage in terms of price and just on
        time (JIT) delivery to meet our client needs. Our supply chain division
        works as&nbsp; Principals &amp; Sourcing agents in countries like U.S.
        A, Europe &amp; China for in-house/other divisions and as well as for
        our valued customers for their needs.
      </p>
      <p>
        With our supply chain division, our company is “one-stop-shop” for your
        complete products and supplies requirements.
      </p>
      <p>
        With project schedules becoming tighter delivery of material on time is
        becoming the essence of the project. We take care of this aspect as well
        as the stringent technical &amp; quality requirements of the customers
        in a professional way and deliver the right product at the right time.
        Our supply chain division is a team of qualified professionals who carry
        varied business experience available in the industry and can manage
        client’s project technical specifications &amp; give clarifications if
        needed. Our team of professionals can assist the customer in selecting
        the correct product according to his specification requirements.
      </p>
      <p>
        Our Supply Chain division has special expertise in the following areas
        with a list of major principals and partners
      </p>
      <p>&nbsp;</p>
      <p>
        <strong>Skids &amp; Packaged Solutions</strong>
      </p>
      <ul>
        <li>Chemical Injection Skids</li>
        <li>Metering Skids</li>
        <li>Pig Launcher &amp; Receiver</li>
        <li>Well Head Control Panel</li>
      </ul>
      <p>&nbsp;</p>
      <p>
        <strong>Instrumentation &amp; Control</strong>
      </p>
      <ul>
        <li>Temperature Indicator, switches, Transmitter</li>
        <li>Pressure Indicator, switches, Transmitter</li>
        <li>Level Indicator, switches, Transmitter</li>
        <li>Flow Indicators, switches, Transmitters</li>
        <li>Instrument, ELV, Communication, Safety Cables</li>
        <li>PID Controllers</li>
        <li>Field Junction Boxes</li>
        <li>Calibration Instrumentation</li>
        <li>PLC, DCS &amp; Safety Systems</li>
      </ul>
      <p>&nbsp;</p>
      <p>
        <strong>Analyzers &amp; Special Systems</strong>
      </p>
      <ul>
        <li>Fire &amp; Gas detectors &amp; system</li>
        <li>Online &amp; Offline Analyzers</li>
        <li>Gas Chromatograph</li>
        <li>Emission Monitoring System</li>
      </ul>
      <p>&nbsp;</p>
      <p>
        <strong>Telecom Equipment &amp; Solution</strong>
      </p>
      <ul>
        <li>CCTV ( Analog &amp; IP based)</li>
        <li>Access Control System</li>
        <li>Car Parking &amp; Barrier System</li>
        <li>Intrusion Detector System</li>
        <li>Burglar Alarm System</li>
        <li>PAGA system</li>
        <li>Fiber Optic Cable &amp; its Accessories</li>
        <li>Wireless Communication System</li>
        <li>LAN/WAN</li>
        <li>VOIP &amp; Solution</li>
        <li>Pipeline monitoring System</li>
      </ul>
      <p>&nbsp;</p>
      <p>
        <strong>Electrical &amp; Power</strong>
      </p>
      <ul>
        <li>LV switchgear &amp; Component</li>
        <li>Power &amp; Transmission Cables</li>
        <li>Transformers</li>
        <li>Motors</li>
      </ul>
      <p>&nbsp;</p>
      <p>
        <strong>Industrial Safety Products</strong>
      </p>
      <ul>
        <li>Conventional &amp; Addressable Fire Alarm System</li>
        <li>Fire Fighting &amp; Fire Suppression System</li>
        <li>Respiratory Protection</li>
        <li>Hand Protection</li>
        <li>Protective Clothing</li>
        <li>Head &amp; Foot Protection</li>
      </ul>
      <p>&nbsp;</p>
      <p>
        <strong>Security Seals for Industry and Transport</strong>
      </p>
      <ul>
        <li>High security seals Cable Lock /Cable Seals</li>
        <li>Metal seals Padlock seals</li>
      </ul>
      <p>&nbsp;</p>
      <p>
        <strong>Tubular &amp; Structural Products</strong>
      </p>
      <p>Line pipe SMLS and Welded Structural Steel</p>
      <p>&nbsp;</p>
      <p>
        <strong>Flanges &amp; Fittings</strong>
      </p>
      <ul>
        <li>Flanges of all types Butt Weld Fittings</li>
        <li>Forged Fittings O’Lets Special Products</li>
      </ul>
      <p>&nbsp;</p>
      <p>
        <strong>Bolting Gasket &amp; Insulation Kits</strong>
      </p>
      <ul>
        <li>Bolting Gaskets Insulation Kits</li>
      </ul>
      <p>&nbsp;</p>
      <p>
        <strong>Valves</strong>
      </p>
      <ul>
        <li>Choke Valves</li>
        <li>Globe Valves</li>
        <li>Ball Valves</li>
        <li>Gate Valves</li>
        <li>Butterfly Valves</li>
        <li>Check Valves</li>
        <li>Control Valves &amp; Actuators</li>
        <li>Pressure Safety Valves</li>
      </ul>
      <p>&nbsp;</p>
      <p>
        <strong>Pumps</strong>
      </p>
      <ul>
        <li>Dosing pumps</li>
        <li>Submersible Pumps</li>
        <li>Centrifugal Pumps</li>
        <li>Reciprocating Pumps</li>
      </ul>
      <p>&nbsp;</p>
      <p>
        <strong>Special Piping Products</strong>
      </p>
      <ul>
        <li>Strainers</li>
        <li>T type Steam Traps</li>
        <li>Sight Glasses</li>
        <li>Pigging Products</li>
        <li>Misc. Products</li>
        <li>Coating &amp; Wrapping</li>
      </ul>

      <p></p>
    </div>
  );
};
export default SupplyChain;
